import { io, type Socket } from 'socket.io-client';
import MsgpackParser from 'socket.io-msgpack-parser';

const { VITE_APP_DOMAIN, VITE_APP_ENV } = import.meta.env;

let socket: Socket | null = null;

const getSocketInstance = () => {
  if (!socket) {
    const isDev = VITE_APP_ENV === 'development';
    socket = io(VITE_APP_DOMAIN, {
      autoConnect: false,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
      transports: ['websocket'],
      path: '/api/v1/socket.io',
      withCredentials: true,
      ...(!isDev && { parser: MsgpackParser }),
    });
  }

  return socket;
};

const resetSocketInstance = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

export { getSocketInstance, resetSocketInstance };
